import React from "react";
import { Plane, Ship, Truck, Package, FileCheck2, Boxes } from "lucide-react";

/*
  Subtle, decorative logistics animation overlay.
  Renders a couple of moving icons (plane / ship / truck / parcels / customs / fulfilment)
  in the background of a section. Designed to be lightweight, light-coloured, and
  positioned via absolute layout — does not block any pointer events.
*/
export default function LogisticsAnimation({
  variant = "all",      // "air" | "sea" | "road" | "ecom" | "customs" | "fulfilment" | "all"
  className = "",
}) {
  const items = pick(variant);
  return (
    <div className={`zp-flight-track ${className}`} aria-hidden="true">
      {items.map((it, i) => (
        <span
          key={i}
          className={it.cls}
          style={{ top: it.top, ...it.style }}
        >
          <it.Icon size={it.size} strokeWidth={1.6} />
        </span>
      ))}
    </div>
  );
}

function pick(v) {
  const all = [
    // Plane crossing upper third
    { Icon: Plane, cls: "zp-flyer", top: "14%", size: 32, style: {} },
    // Slower plane higher up
    { Icon: Plane, cls: "zp-flyer delay-2 slow", top: "6%", size: 22, style: {} },
    // Ship near middle
    { Icon: Ship, cls: "zp-flyer slow", top: "44%", size: 30, style: { animationDuration: "44s" } },
    // Truck rolling along the bottom (right→left)
    { Icon: Truck, cls: "zp-driver", top: "78%", size: 28, style: {} },
    // E-commerce parcel floats
    { Icon: Package, cls: "zp-floater", top: "30%", size: 22, style: { left: "12%", animationDelay: "-2s" } },
    { Icon: Boxes, cls: "zp-floater", top: "60%", size: 22, style: { right: "16%", animationDelay: "-4s" } },
    // Customs doc
    { Icon: FileCheck2, cls: "zp-floater", top: "20%", size: 22, style: { right: "8%", animationDelay: "-6s" } },
  ];
  if (v === "all") return all;
  const map = {
    air: all.filter((x) => x.Icon === Plane),
    sea: all.filter((x) => x.Icon === Ship),
    road: all.filter((x) => x.Icon === Truck),
    ecom: all.filter((x) => x.Icon === Package || x.Icon === Boxes),
    customs: all.filter((x) => x.Icon === FileCheck2),
    fulfilment: all.filter((x) => x.Icon === Boxes || x.Icon === Package),
  };
  return map[v] || all;
}
